import { MerchantTierInfoModel } from "@features/tiering/data";
import {
  MerchantTierInfoEntity,
  MerchantTiersEntity,
  TierEntity,
} from "@features/tiering/domain";

export function mapMerchantTierInfo(
  tier: MerchantTierInfoModel,
): MerchantTierInfoEntity {
  return {
    ...tier,
    startDate: new Date(tier.startDate),
    endDate: new Date(tier.endDate),
  };
}

export function mapMerchantTiers(
  tiers: TierEntity[],
  merchantTierInfo: MerchantTierInfoEntity,
): MerchantTiersEntity {
  const setTierProgress = (tier: TierEntity) => {
    if (tier.index < merchantTierInfo.currentLoyaltyTierIndex) return 100;
    if (tier.index > merchantTierInfo.currentLoyaltyTierIndex) return 0;

    const progressPercentage =
      (merchantTierInfo.achievedOrders / tier.targetOrders) * 100;

    return progressPercentage;
  };

  const tiersList = tiers.map(tier => ({
    ...tier,
    isCurrent: tier.index === merchantTierInfo.currentLoyaltyTierIndex,
    isActual: tier.index === merchantTierInfo.actualLoyaltyTierIndex,
    progress: setTierProgress(tier),
  }));

  // sort by index ascending
  tiersList.sort((a, b) => a.index - b.index);

  const lastTier = tiersList.length - 1;

  const targetTier =
    merchantTierInfo.currentLoyaltyTierIndex < lastTier
      ? tiersList.find(
          tier => tier.index === merchantTierInfo.currentLoyaltyTierIndex + 1,
        )!
      : tiersList[lastTier];

  const currentLoyaltyTier = tiersList.find(
    tier => tier.index === merchantTierInfo.currentLoyaltyTierIndex,
  );

  return {
    ...merchantTierInfo,
    currentLoyaltyTierIcon: currentLoyaltyTier?.icon,
    currentLoyaltyTierTitle: currentLoyaltyTier?.displayName,
    tiers: tiersList,
    targetTierInfo: {
      icon: targetTier.icon,
      displayName: targetTier.displayName,
      targetOrders: targetTier.targetOrders,
      ordersLeft: targetTier.targetOrders - merchantTierInfo.achievedOrders,
      progressPercentage:
        (merchantTierInfo.achievedOrders / targetTier.targetOrders) * 100,
    },
  };
}
